import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/image/learningportal.svg';
import { useLoginMutation } from '../features/auth/authApi';

const Login = () => {
    const {pathname}=useLocation();

    const [userData, setUserData]=useState({});
    const handleChangeInput=(event)=>{
      const {name,value}=event.target;
      setUserData(prev=>({...prev,[name]:value}))
    }
    const [loginFunc,{isLoading,data,isSuccess,isError,error}] =useLoginMutation();
    const handleSubmit =(e)=>{
      e.preventDefault();
    
      loginFunc(userData)}
    
  

  return (
<>
<section className="py-6 bg-primary h-screen grid place-items-center">
  <div className="mx-auto max-w-md px-5 lg:px-0">
    <div>
      <img className="h-12 mx-auto" src={logo} />
      <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
        Sign in to   {pathname.includes('admin') ? 'Admin Account' :'Student Account'}
        
      </h2>
    </div>
    <form className="mt-8 space-y-6" action="#" method="POST" onSubmit={handleSubmit}>
      <input type="hidden" name="remember" defaultValue="true" />
      <div className="rounded-md shadow-sm -space-y-px">
        <div>
          <label htmlFor="email-address" className="sr-only">Email address</label>
          <input onChange={handleChangeInput} id="email-address" name="email" type="email" autoComplete="email" required className="login-input rounded-t-md" placeholder="Email address" />
        </div>
        <div>
          <label htmlFor="password" className="sr-only">Password</label>
          <input  onChange={handleChangeInput}  id="password" name="password" type="password" autoComplete="current-password" required className="login-input rounded-b-md" placeholder="Password" />
        </div>
      </div>
      <div className="flex items-center justify-end">
        <div className="text-sm">
          <a href="#" className="font-medium text-violet-600 hover:text-violet-500">
            Forgot your password?
          </a>
        </div>
      </div>
      <div>
        <button type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
          Sign in
        </button>
    <Link to={'/register'}> Register</Link>
      </div>
    </form>
  </div>
</section>

</>  )
}

export default Login